import { render, staticRenderFns } from "./StoreProductTitle.vue?vue&type=template&id=74928409&scoped=true&"
import script from "./StoreProductTitle.vue?vue&type=script&lang=js&"
export * from "./StoreProductTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74928409",
  null
  
)

export default component.exports